import authRoleApi from "../../api/rest/authRoleApi";

const getAllAuthRole = () => async (dispatch) => {
  const res = await authRoleApi.getAll();
  if (res.data) {
    return res.data;
  }
  return null;
}

const getAuthRoleById = (authRoles, authRoleId) => {
  return authRoles.find((authRole) => authRole.id === authRoleId);
}

export const authRoleBusiness = {
  getAllAuthRole,
  getAuthRoleById,
};